import { ChangeDetectionStrategy, Component } from '@angular/core';

import { OverAskConfig } from '@frontend/sports/common/client-config-data-access';
import { SyncUserSettingsService, UserService } from '@frontend/sports/user/feature';
import { Store } from '@ngrx/store';
import { ArcRestrictionService } from 'packages/sports/web/app/src/arc/arc-restriction.service';

import { IBetslipRootState } from '../../../../../base/store/state';
import { BetslipResultConfigurationBase } from '../../../services/result-configuration.service';
import BaseResultComponent from '../base-result.component';

@Component({
    selector: 'bs-digital-linear-result',
    templateUrl: './linear-result.component.html',
    styleUrls: ['./linear-result.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearResultComponent extends BaseResultComponent {
    constructor(
        arcRestrictionService: ArcRestrictionService,
        store: Store<IBetslipRootState>,
        userService: UserService,
        resultConfiguration: BetslipResultConfigurationBase,
        overAskConfig: OverAskConfig,
        userSettings: SyncUserSettingsService,
    ) {
        super(arcRestrictionService, resultConfiguration, store, userService, overAskConfig, userSettings);
    }
}
